import React from 'react';
import { useDispatch } from 'react-redux';
import { loadUserFromSpoofing } from 'actions/user';
import queryString from 'query-string';

export const Spoofing = ({ location, history }) => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        const values = queryString.parse(location.search);
        const spoof = (email, callback) => dispatch(loadUserFromSpoofing(email, callback));

        spoof(values.email, () => history.push('/'));
    }, []);

    return (
        <div className="flex flex-center flex-column">
            <h3>Spoofing login into e4enable from Partner Portal...</h3>
            <div>
                <i className="fa fa-spin fa-cog text-lg mr10" />
                Please Wait
            </div>
        </div>
    );
};

export default Spoofing;
